<!-- <p>tos works!</p> -->

<div class="tos-page" *ngIf="appSettings">

    <div class="tos-card">

        <div class="tos-header">
            <h1>Software Licence Agreement - Terms of Service</h1>
            <!-- <span>PRISMPdM</span> -->
        </div>

        <div class="tos-content" #slaContent (scroll)="onScroll()">
            <span>
                By continuing using PRISMPdM you accept our Privacy Policy.
            </span>

            <a [href]="ToS_Link" target="_blank" rel="noopener noreferrer">
                Read our Privacy Policy
            </a>

            <!-- <h2>1. Agreement</h2>

            <p>
                By accessing and using PRISMPdM, you agree to the terms and conditions
                set out in this Software Licence Agreement.
            </p>

            <h2>2. Authorised Use</h2>

            <p>
                PRISMPdM is provided for authorised business use only. You must not
                share your account credentials or allow unauthorised persons to access
                the application.
            </p>

            <h2>3. Access and Security</h2>

            <p>
                You are responsible for maintaining the confidentiality of your
                authentication credentials and for all activity carried out using
                your account.
            </p>

            <h2>4. Data</h2>

            <p>
                Information entered into PRISMPdM must be accurate and appropriate
                for the intended use of the application. You must not knowingly
                enter malicious, unlawful or unauthorised content.
            </p>

            <h2>5. Availability</h2>

            <p>
                PRISMPdM may occasionally be unavailable due to maintenance,
                upgrades or circumstances outside of our control.
            </p>

            <h2>6. Acceptance</h2>

            <p>
                By selecting <strong>Accept tos</strong>, you confirm that you have
                read and understood this agreement and agree to be bound by its
                terms.
            </p>

            <div class="tos-end">
                End of agreement
            </div> -->

        </div>

        <div class="tos-footer">

            <div class="tos-status">
                <!-- <span *ngIf="!canAccept">
                    Please scroll to the bottom of the agreement.
                </span>

                <span *ngIf="canAccept">
                    You have reached the end of the agreement.
                </span> -->
            </div>

            <div class="tos-actions">

                <button type="button" class="btn-decline" (click)="decline()">
                    Decline
                </button>

                <button type="button" class="btn-accept" [disabled]="!canAccept" (click)="accept()">
                    Accept
                </button>

            </div>

        </div>

    </div>

</div>